// The one table of date rules (the warehouse team, 2026-10-28): blocked (the big red message) only
// what is not a valid date — it cannot be read, or its year is a typo — and a shipment dated after
// today, which can't have happened yet; every other rule about when (past, future, after the cancel
// date, before the ready date) is an orange "Are you sure?" the team may go on from, as routing and
// shipping late happens. The cell checks (`dates.ts`) and the pickup and
// shipment checks (`shipping.ts`) ask here. Pre-route keeps its own checks (`pre-route.ts`).

export const DATE_RULES = {
  /** More than a year away, or before 2025: a typo (2062). */
  wrongYear: "error",
  readyInPast: "warning",
  readyAfterCancel: "warning",
  readyAfterSchedShip: "warning",
  schedShipInPast: "warning",
  schedShipBeforeReady: "warning",
  schedShipAfterCancel: "warning",
  routedOnInFuture: "warning",
  routedOnBeforePtDate: "warning",
  pickupInPast: "warning",
  pickupAfterCancel: "warning",
  pickupBeforeReady: "warning",
  pickupBeforeStart: "warning",
  /** A shipment is marked after it left: never dated after today. */
  shipDateInFuture: "error",
  shipDateAfterCancel: "warning",
} as const satisfies Record<string, "error" | "warning">;

export type DateRule = keyof typeof DATE_RULES;
export type DateLevel = (typeof DATE_RULES)[DateRule];

/** A broken date rule: what the table says it is, and the words. */
export interface DateProblem {
  rule: DateRule;
  level: DateLevel;
  message: string;
}

export const dateProblem = (rule: DateRule, message: string): DateProblem => ({
  rule,
  level: DATE_RULES[rule],
  message,
});

/** Adds a broken rule to a check's errors or warnings, as the table says. */
export function pushDateRule(checked: { errors: string[]; warnings: string[] }, rule: DateRule, message: string) {
  (DATE_RULES[rule] === "error" ? checked.errors : checked.warnings).push(message);
}
